<template>
  <div>
    <b-card>
      <Downloads
        :dates="this.$store.state.calendar.dates"
        :selected-domains="this.$store.state.auth.selectedDomains"
      />
    </b-card>
  </div>
</template>

<script>
import Downloads from "@/components/user/Downloads";

export default {
  name: "Files",
  components: { Downloads }
};
</script>

<style scoped></style>
